import { render } from "./Batches_Create.vue?vue&type=template&id=0642223e"
import script from "./Batches_Create.vue?vue&type=script&lang=js"
export * from "./Batches_Create.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__